import { useState, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './SearchInput.css';

interface SearchInputProps {
  placeholder?: string;
  onSearch?: (query: string) => void;
}

/**
 * 搜尋輸入框元件
 * 對應 UXC-common-SearchInput-002
 * Automatically syncs with URL keyword parameter
 */
const SearchInput = ({
  placeholder = '搜尋...',
  onSearch,
}: SearchInputProps) => {
  const [searchParams] = useSearchParams();
  const keywordFromUrl = searchParams.get('keyword') || '';
  const [value, setValue] = useState(keywordFromUrl);

  // Sync with URL keyword parameter when it changes
  useEffect(() => {
    setValue(keywordFromUrl);
  }, [keywordFromUrl]);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (onSearch) {
        // 即使為空字串也執行搜尋，允許用戶查看所有結果
        onSearch(value.trim());
      }
    },
    [value, onSearch]
  );

  const handleClear = useCallback(() => {
    setValue('');
    if (onSearch) {
      onSearch('');
    }
  }, [onSearch]);

  return (
    <form className="search-input" onSubmit={handleSubmit}>
      <input
        type="text"
        className="search-input__field"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        aria-label={placeholder}
      />
      {value && (
        <button
          type="button"
          className="search-input__clear"
          onClick={handleClear}
          aria-label="清除搜尋"
        >
          ✕
        </button>
      )}
      <button type="submit" className="search-input__button" aria-label="搜尋">
        🔍
      </button>
    </form>
  );
};

export default SearchInput;
